import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import ReportEdit from "components/reports/ReportEdit";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import saveAs from 'file-saver';
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import EmprestimoPatrimonio from "model/patrimonio/EmprestimoPatrimonio";
import ItemEmprestimo from "model/patrimonio/ItemEmprestimo";
import Patrimonio from "model/patrimonio/Patrimonio";
import PessoaCadastro from "pages/administracao/cadastro/pessoa/PessoaCadastro";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnBodyOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import EmprestimoPatrimonioService from "service/patrimonio/EmprestimoPatrimonioService";
import ItemEmprestimoService from "service/patrimonio/ItemEmprestimoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { patrimonioCompleteMethod, patrimonioItemTemplate, produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";
import { converterData, converterDataHora } from "utils/convert";
import { generateKey } from "utils/generateKey";
import SelecaoLotesEmprestimoModal from "./SelecaoLotesEmprestimoModal";

const emprestimoPatrimonioService = new EmprestimoPatrimonioService();
const itemEmprestimoService = new ItemEmprestimoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function EmprestimoPatrimonioCadastro() {
    const [alterando, setAlterando] = useState<boolean>(false);

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [emprestimoPatrimonio, setEmprestimoPatrimonio] = useState<EmprestimoPatrimonio>(new EmprestimoPatrimonio());

    const [pessoas, setPessoas] = useState<Pessoa[]>([]);
    const [pessoasFiltradas, setPessoasFiltradas] = useState<Pessoa[]>([]);
    const [titulo, setTitulo] = useState<string>('Empréstimo');
    const [editando, setEditando] = useState<boolean>(false);

    const [temProduto, setTemProduto] = useState<boolean>(false);
    const [editaRelatorios, setEditaRelatorios] = useState<boolean>(false);
    const [patrimonios, setPatrimonios] = useState<Patrimonio[]>([]);
    const [patrimoniosFiltrados, setPatrimoniosFiltrados] = useState<Patrimonio[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [modalInutilizavel, setModalInutilizavel] = useState<{ visible: boolean, data: any, isItem: boolean }>({ visible: false, data: null, isItem: false });
    const [editarLote, setEditarLote] = useState<{ visible: boolean, itemEmprestimo: ItemEmprestimo, rowIndex: number, isItem: boolean }>({ visible: false, itemEmprestimo: new ItemEmprestimo(), rowIndex: -1, isItem: false });
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);
    const [visibleCadastroPessoa, setVisibleCadastroPessoa] = useState<boolean>(false);

    const [visibleDuplicarEmprestimo, setVisibleDuplicarEmprestimo] = useState<boolean>(false);
    const [emprestimosPatrimonio, setEmprestimosPatrimonio] = useState<EmprestimoPatrimonio[]>([]);
    const [emprestimosPatrimonioExpandidos, setEmprestimosPatrimonioExpandidos] = useState<EmprestimoPatrimonio[] | any>([]);
    const [emprestimoDuplicar, setEmprestimoDuplicar] = useState<EmprestimoPatrimonio | any>(new EmprestimoPatrimonio());


    const inputNomeRef = useRef<any>(null);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
        emprestimoPatrimonioService.pessoas().then((data) => {
            setPessoas(data);
        }).catch((error) => {
            console.log(error);
        })
        emprestimoPatrimonioService.patrimonios().then((data) => {
            setPatrimonios(data);
        }).catch((error) => {
            console.log(error);
        })
        emprestimoPatrimonioService.produtos().then((data) => {
            setProdutos(data);
        }).catch((error) => {
            console.log(error);
        });

        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioTemAcao(resposta, "RELATORIO_EMPRESTIMO")) {
                setEditaRelatorios(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
    }, [])

    useEffect(() => {
        if (emprestimoPatrimonio.itens.some(item => item.itemProduto)) {
            setTemProduto(true);
        }
    }, [emprestimoPatrimonio]);

    useEffect(() => {
        if (visibleDuplicarEmprestimo) {
            emprestimoPatrimonioService.emprestimos().then((resposta) => {
                setEmprestimosPatrimonio(resposta);
                console.log(emprestimosPatrimonio);
            }).catch((erro) => {
                console.log(erro);
            });
        }
    }, [visibleDuplicarEmprestimo])

    function validar() {

        if (!emprestimoPatrimonio.pessoaEmprestada) {
            setError("pessoaEmprestada", { type: "manual", message: "Pessoa Emprestada é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    function usuarioTemAcao(acoes: any, acao: any): boolean {
        return acoes.some((a: any) => a.sigla === acao);
    }



    const botoesExtra = <>
        <Button label="Adicionar Pessoa" style={{ marginLeft: 10 }} onClick={() => { setVisibleCadastroPessoa(true) }} />
        {emprestimoPatrimonio.status === "CRIADO" && emprestimoPatrimonio.id ? <Button disabled={alterando} label="Emprestar" onClick={() => beforeEmprestar()} style={{ marginLeft: 8 }} /> : null}
        {emprestimoPatrimonio.status === "EMPRESTADO" ? <Button disabled={alterando} label="Devolução" onClick={() => { beforeDevolver() }} style={{ marginLeft: 8 }} /> : null}
        {emprestimoPatrimonio.status !== "CANCELADO" && emprestimoPatrimonio.status !== "DEVOLVIDO" && emprestimoPatrimonio.id ? <Button disabled={alterando} label="Cancelar" onClick={() => cancelar()} style={{ marginLeft: 8 }} /> : null}
        {emprestimoPatrimonio.id ? (editaRelatorios ? (
            <SplitButton
                onClick={() => getRelatorioEmprestimo()}
                label="Relat. Empréstimo" style={{ width: 200, marginLeft: 8 }}
                model={[
                    { label: 'Editar relatório', command: () => { setVisibleEditarRelatorio(true) } }
                ]}

            />
        ) :
            <Button onClick={() => getRelatorioEmprestimo()} label="Relat. Empréstimo" style={{ width: 200, marginLeft: 8 }} />
        ) : null}
        {!editando ? <Button label="Duplicar" style={{ marginLeft: 10 }} onClick={() => { setVisibleDuplicarEmprestimo(true) }} /> : null}
    </>

    function getRelatorioEmprestimo() {
        emprestimoPatrimonioService.editar(emprestimoPatrimonio).then(() => {
            emprestimoPatrimonioService.relatorioEmprestimo(emprestimoPatrimonio.id).then((data) => {
                const file = new Blob([data], { type: 'application/pdf' });
                saveAs(file, `Emprestimo.pdf`);
            }).catch((error) => {
                console.log(error);
            });
        })
    }

    const emprestar = () => {
        startLoading();
        emprestimoPatrimonioService.editar(emprestimoPatrimonio).then(() => {
            emprestimoPatrimonioService.emprestar(emprestimoPatrimonio.id).then(() => {
                emprestimoPatrimonio.status = 'EMPRESTADO';
                consultar();
                msgSucesso('Emprestado', 'Emprestimo realizado com sucesso');
                stopLoading();
            }).catch((err) => {
                msgErro('Erro ao Emprestar', err?.data?.message || "");
                limpaLotes();
                stopLoading();
            });
        })
    }
    const devolvido = () => {
        startLoading();
        emprestimoPatrimonioService.editar(emprestimoPatrimonio).then(() => {
            emprestimoPatrimonioService.devolvido(emprestimoPatrimonio.id).then(() => {
                consultar();
                msgSucesso('Devolução', 'devolvido com sucesso');
                stopLoading();
            }).catch((err) => {
                msgErro('Erro ao Devolver', err?.data?.message || "");
                limpaLotes();
                stopLoading();
            });

        })
    }
    const cancelar = () => {
        startLoading();
        emprestimoPatrimonioService.cancelar(emprestimoPatrimonio.id).then(() => {
            consultar();
            msgSucesso('Cancelado', 'Emprestimo Cancelado com sucesso');
            stopLoading();
        }).catch((err) => {
            msgErro('Erro ao Cancelar', err?.data?.message || "");
            stopLoading();
        });
    }
    const itemEmprestar = (itemEmprestimo: ItemEmprestimo) => {
        startLoading();
        emprestimoPatrimonioService.editar(emprestimoPatrimonio).then(() => {
            itemEmprestimoService.emprestar(itemEmprestimo).then(() => {
                consultar();
                msgSucesso('Emprestado', 'Item emprestado com sucesso');
                stopLoading();
            }).catch((err) => {
                msgErro('Erro ao Emprestar', err?.data?.message || "");
                stopLoading();
            });
        })
    }
    const itemDevolvido = (itemEmprestimo: ItemEmprestimo) => {
        startLoading();
        emprestimoPatrimonioService.editar(emprestimoPatrimonio).then(() => {
            itemEmprestimoService.devolvido(itemEmprestimo).then(() => {
                consultar();
                msgSucesso('Devolvido', 'Item devolvido com sucesso');
                stopLoading();
            }).catch((err) => {
                msgErro('Erro ao Emprestar', err?.data?.message || "");
                stopLoading();
            });
        })
    }

    const consultar = () => {
        emprestimoPatrimonioService.consultar(emprestimoPatrimonio.id)
            .then((data: EmprestimoPatrimonio) => {
                setAlterando(false);
                setEmprestimoPatrimonio(data);
            }).catch((e) => console.error(e));
    }

    const itemCancelar = (id: number) => {
        startLoading();
        itemEmprestimoService.cancelar(id).then(() => {
            consultar();
            msgSucesso('Cancelado', 'Item cancelado com sucesso');
            stopLoading();
        }).catch((err) => {
            msgErro('Erro ao Emprestar', err?.data?.message || "");
            stopLoading();
        });
    }

    const editorPatrimonio = (options: any) => {
        return <AutoComplete
            dropdown
            value={options.rowData.patrimonio?.produto.nome}
            disabled={options.rowData.status !== 'CRIADO' || options.rowData.itemProduto}
            placeholder="Selecione um Patrimonio"
            style={{ width: '100%' }}
            inputStyle={{ width: '100%' }}
            field="nome"
            itemTemplate={(item: Patrimonio) => patrimonioItemTemplate(item)}
            suggestions={patrimoniosFiltrados}
            completeMethod={(e) => {
                let filtered = patrimonioCompleteMethod(patrimonios, e.query);
                setPatrimoniosFiltrados(filtered);
            }}
            onChange={(e) => {
                let emprestimoPatrimonioLocal = JSON.parse(JSON.stringify(emprestimoPatrimonio));
                if (typeof e.target.value == "string") {
                    let patr = new Patrimonio();
                    patr.produto = new Produto();
                    patr.produto.nome = e.target.value;
                    emprestimoPatrimonioLocal.itens[options.rowIndex].patrimonio = patr;
                    setAlterando(true);
                } else {
                    emprestimoPatrimonioLocal.itens[options.rowIndex].patrimonio = e.target.value;
                    setAlterando(true);
                }
                options.rowData['patrimonio'] = emprestimoPatrimonioLocal.itens[options.rowIndex].patrimonio;
                setEmprestimoPatrimonio(emprestimoPatrimonioLocal);
            }}

        />
    }

    const editorProduto = (options: any) => {
        return <AutoComplete
            disabled={options.rowData.status !== 'CRIADO' || !options.rowData.itemProduto}
            dropdown
            placeholder="Selecione o produto"
            style={{ width: '100%' }}
            inputStyle={{ width: '100%' }}
            value={options.rowData.produto?.nome}
            suggestions={produtosFiltrados}
            field="nome"
            className={errors.produto ? "p-invalid" : ""}
            itemTemplate={(item: Produto) => produtoItemTemplate(item)}
            completeMethod={(e) => {
                let filtered = produtoCompleteMethod(produtos, e.query);
                setProdutosFiltrados(filtered);
            }}
            onChange={(e) => {
                let emprestimoPatrimonioLocal = JSON.parse(JSON.stringify(emprestimoPatrimonio));
                if (typeof e.target.value == "string") {
                    let prod = new Produto();
                    prod.nome = e.target.value;
                    emprestimoPatrimonioLocal.itens[options.rowIndex].produto = prod;
                    emprestimoPatrimonioLocal.itens[options.rowIndex].lotes = [];
                    setAlterando(true);
                } else {
                    emprestimoPatrimonioLocal.itens[options.rowIndex].produto = e.target.value;
                    emprestimoPatrimonioLocal.itens[options.rowIndex].lotes = [];
                    setAlterando(true);
                }
                options.rowData['produto'] = emprestimoPatrimonioLocal.itens[options.rowIndex].produto;
                setEmprestimoPatrimonio(emprestimoPatrimonioLocal);
            }}
        />
    }

    const editorQuantidade = (options: any) => {
        return <InputNumber disabled={options.rowData.status !== 'CRIADO' || !options.rowData.itemProduto}
            value={options.rowData.quantidadeEmprestada} useGrouping={false}
            onFocus={(e) => e.target.select()}
            locale="pt-BR"
            minFractionDigits={1} maxFractionDigits={5} maxLength={15}
            onChange={(e) => {
                setAlterando(true);
                let emprestimoPatrimonioLocal = JSON.parse(JSON.stringify(emprestimoPatrimonio));
                emprestimoPatrimonioLocal.itens[options.rowIndex].lotes = [];
                emprestimoPatrimonioLocal.itens[options.rowIndex].quantidadeEmprestada = e.value;
                options.rowData['quantidadeEmprestada'] = emprestimoPatrimonioLocal.itens[options.rowIndex].quantidadeEmprestada;
                setEmprestimoPatrimonio(emprestimoPatrimonioLocal);
            }}
            style={{ width: '30%' }}
        />
    }

    const beforeDevolver = () => {
        for (let i = 0; emprestimoPatrimonio.itens.length > i; i++) {
            if (emprestimoPatrimonio.itens[i].inutilizavel) {
                if (emprestimoPatrimonio.itens[i].itemProduto && (!emprestimoPatrimonio.itens[i].lotes.some(lotes => lotes.quantidadeInutilizavel != null && lotes.quantidadeInutilizavel != 0))) {
                    setModalInutilizavel({ visible: false, data: null, isItem: false });
                    setEditarLote({ visible: true, itemEmprestimo: emprestimoPatrimonio.itens[i], rowIndex: i, isItem: false })
                    return;
                } else if (!emprestimoPatrimonio.itens[i].itemProduto && !emprestimoPatrimonio.itens[i].observacaoInutilizavel) {
                    setEditarLote({ visible: false, itemEmprestimo: new ItemEmprestimo(), rowIndex: -1, isItem: false })
                    setModalInutilizavel({ visible: true, data: emprestimoPatrimonio.itens[i], isItem: false });
                    return;
                }
            }
        }
        setEditarLote({ visible: false, itemEmprestimo: new ItemEmprestimo(), rowIndex: -1, isItem: false })
        setModalInutilizavel({ visible: false, data: null, isItem: false });
        devolvido();
    }

    const beforeEmprestar = () => {
        for (let i = 0; emprestimoPatrimonio.itens.length > i; i++) {
            if (emprestimoPatrimonio.itens[i].itemProduto && emprestimoPatrimonio.itens[i].lotes.length == 0) {
                setEditarLote({ visible: true, itemEmprestimo: emprestimoPatrimonio.itens[i], rowIndex: i, isItem: false });
                return;
            }
        }
        setEditarLote({ visible: false, itemEmprestimo: new ItemEmprestimo(), rowIndex: -1, isItem: false })
        emprestar();
    }

    const emprestaProduto = () => {
        setTemProduto(emprestimoPatrimonio.itens.some(item => item.itemProduto))
    }

    const limpaLotes = () => {
        let emprestimoPatrimonioLocal = { ...emprestimoPatrimonio };

        for (let i = 0; i < emprestimoPatrimonio.itens.length; i++) {
            const item = emprestimoPatrimonioLocal.itens[i];

            if (item.itemProduto && item.status === "CRIADO") {
                emprestimoPatrimonioLocal.itens[i] = {
                    ...item,
                    lotes: [],
                };
            }
            if (item.itemProduto && item.status === "EMPRESTADO") {
                for (let j = 0; j < item.lotes.length; j++) {
                    emprestimoPatrimonioLocal.itens[i].lotes[j] = {
                        ...item.lotes[j],
                        quantidadeInutilizavel: 0,
                    };
                }
            }

            if (!item.itemProduto) {
                emprestimoPatrimonioLocal.itens[i] = {
                    ...item,
                    observacaoInutilizavel: "",
                };
            }
        }
        setEmprestimoPatrimonio(emprestimoPatrimonioLocal);
    }

    function normalizeString(str: string) {
        str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
        str = str.replace(/[àáâãäå]/, "a");
        str = str.replace(/[ÈÉÊË]/, "E");
        str = str.replace(/[èéêë]/, "e");
        str = str.replace(/[ÌÍÎÏ]/, "I");
        str = str.replace(/[ìíîï]/, "i");
        str = str.replace(/[ÒÓÔÕÖ]/, "O");
        str = str.replace(/[òóôõö]/, "o");
        str = str.replace(/[ÙÚÛÜ]/, "U");
        str = str.replace(/[ùúûü]/, "u");

        return str;
    }

    function pessoaMethod(pessoas: Pessoa[], query: string): Pessoa[] {

        let filtered: Pessoa[] = [];
        for (let i = 0; i < pessoas.length; i++) {
            let pessoa = pessoas[i];
            let documento = pessoa.numeroDocumento.toString();

            if (normalizeString(pessoa.nome.toLowerCase()).indexOf(normalizeString(query.toLowerCase())) == 0) {
                filtered.push(pessoa);
            } else if (normalizeString(documento?.toLowerCase() || "").indexOf(normalizeString(query.toLowerCase())) == 0) {
                filtered.push(pessoa);
            } else if (normalizeString(documento + " - " + pessoa.nome).toLowerCase().indexOf(normalizeString(query.toLowerCase())) == 0) {
                filtered.push(pessoa);
            }
        }
        return filtered;
    }

    function duplicar(id: number) {
        emprestimoPatrimonioService.consultar(id).then(data => {
            let itens = data.itens.map(item => {
                item.key = generateKey();
                item.id = 0;
                item.dataDevolucao = null;
                item.dataEmprestimo = null;
                item.status = "CRIADO";
                item.inutilizavel = false;
                item.emprestimoPatrimonio = new EmprestimoPatrimonio();
                return item;
            })

            setEmprestimoPatrimonio({
                ...emprestimoPatrimonio,
                codigo: data.codigo,
                pessoaEmprestada: data.pessoaEmprestada,
                dataEmprestimo: null,
                dataPrevistaDevolucao: data.dataPrevistaDevolucao,
                status: "CRIADO",
                observacao: data.observacao,
                itens: itens
            })
        })
    }

    function headerTemplate(data: EmprestimoPatrimonio) {

        return (
            <>
                <span className="vertical-align-middle ml-2 font-bold line-height-3">{data.pessoaEmprestada?.nome}</span>
            </>
        );
    };

    const rowExpansionTemplate = (rowData: EmprestimoPatrimonio) => {
        return (
            <DataTable value={rowData.itens} tableStyle={{ minWidth: '60rem' }} dataKey="id" emptyMessage="Nenhum registro encontrado">
                <Column field="patrimonio.codigo" header="Patrimonio" />
                <Column
                    field="produto" header="Produto"
                    body={(rowData) => rowData.itemProduto ? rowData.produto?.nome : rowData.patrimonio?.produto?.nome}
                />
                <Column field="status" header="Status" body={(rowData) => itemEmprestimoService.getStatus(rowData.status)} />
                <Column field="inutilizavel" header="Inutilizavel?" style={{ width: '5em', textAlign: "center" }} body={(rowData) => <Checkbox checked={rowData.inutilizavel} />} />
            </DataTable>
        );
    }

    return (

        <BaseCadastro model={emprestimoPatrimonio} service={emprestimoPatrimonioService} botoesExtra={botoesExtra} novoCadastro getNewModel={() => new EmprestimoPatrimonio()} setModel={(value: EmprestimoPatrimonio) => {
            setEmprestimoPatrimonio(value)
            setAlterando(false)

        }} validar={() => validar()} urlService="/emprestimoPatrimonio" pathCadastro="/emprestimoPatrimonio" tituloPagina={'EmprestimoPatrimonio'}>
            {visibleDuplicarEmprestimo ?
                <Dialog header="Duplicar Emprestimo" visible={visibleDuplicarEmprestimo} style={{ width: '80vw' }} onHide={() => setVisibleDuplicarEmprestimo(false)}
                    footer={<>
                        <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisibleDuplicarEmprestimo(false)} />
                        <Button label="Duplicar" icon="pi pi-check"
                            onClick={() => {
                                duplicar(emprestimoDuplicar.id);
                                setVisibleDuplicarEmprestimo(false);
                            }}
                        />
                    </>}
                >
                    <div className="row">
                        <label className="col col-sm-12">Selecione o emprestimo que deseja duplicar</label>
                        <div className="col col-sm-12">
                            <DataTable
                                value={emprestimosPatrimonio}
                                expandedRows={emprestimosPatrimonioExpandidos}
                                scrollable
                                selection={emprestimoDuplicar}
                                onSelectionChange={(e) => setEmprestimoDuplicar(e.value)}
                                selectionMode="single"
                                onRowToggle={(e) => setEmprestimosPatrimonioExpandidos(e.data)}
                                dataKey="id" tableStyle={{ minWidth: '60rem' }}
                                rowExpansionTemplate={rowExpansionTemplate}
                                emptyMessage="Nenhum registro encontrado"
                            >
                                <Column expander={true} style={{ width: '5rem' }} />
                                <Column field="pessoaEmprestada.nome" header="Pessoa Emprestada" />
                                <Column field="status" header="Status" body={(rowData) => emprestimoPatrimonioService.getStatus(rowData.status)} />
                                <Column field="dataEmprestimo" header="Data Empréstimo" body={(rowData) => rowData.dataEmprestimo ? converterData(rowData.dataEmprestimo) : ""} />
                                <Column field="dataPrevistaDevolucao" header="Data Prevista para Devolução" body={(rowData) => rowData.dataPrevistaDevolucao ? converterData(rowData.dataPrevistaDevolucao) : ""} />
                            </DataTable>
                        </div>
                    </div>
                </Dialog>
                : null}
            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            {visibleEditarRelatorio && <Dialog header="Editar Relatório" visible={visibleEditarRelatorio} style={{ width: '50vw' }} onHide={() => setVisibleEditarRelatorio(false)}>
                <ReportEdit titulo="Relatório de Empréstimo" nomeAcao="RELATORIO_EMPRESTIMO" testarRelatorio={() => { }} />
            </Dialog>}
            <Dialog header="Cadastro de Pessoa" visible={visibleCadastroPessoa} style={{ width: '75vw' }} onHide={() => setVisibleCadastroPessoa(false)}>
                <PessoaCadastro onSave={(pessoa: Pessoa) => {
                    setVisibleCadastroPessoa(false);
                    emprestimoPatrimonioService.pessoas().then((data) => {
                        setPessoas(data);
                    }).catch((error) => {
                        msgErro('Erro', 'Erro ao encontrar pessoas');
                    });
                }} isModal />
            </Dialog>
            <SelecaoLotesEmprestimoModal
                visible={editarLote.visible}
                setVisible={(visible) => { setEditarLote({ visible: visible, itemEmprestimo: new ItemEmprestimo(), rowIndex: -1, isItem: false }) }}
                produto={editarLote.itemEmprestimo.produto || new Produto()}
                quantidade={editarLote.itemEmprestimo.quantidadeEmprestada}
                lotes={editarLote.itemEmprestimo.lotes}
                inutilizavel={editarLote.itemEmprestimo.inutilizavel}
                onConfirm={(lotes) => {

                    editarLote.itemEmprestimo.lotes = lotes;
                    const comps = [...emprestimoPatrimonio.itens];
                    comps[editarLote.rowIndex] = editarLote.itemEmprestimo;

                    if (lotes.length > 0 && editarLote.itemEmprestimo.quantidadeEmprestada == 0) {
                        let qtdTotal = 0;
                        lotes.forEach(lote => {
                            qtdTotal = ((qtdTotal * 100000000) + (lote.quantidadeEmprestada * 100000000)) / 100000000;
                        })
                        comps[editarLote.rowIndex].quantidadeEmprestada = qtdTotal;
                    }

                    setEmprestimoPatrimonio({ ...emprestimoPatrimonio, itens: comps });

                    if (editarLote.isItem) {
                        if (editarLote.itemEmprestimo.inutilizavel) {
                            itemDevolvido(emprestimoPatrimonio.itens[editarLote.rowIndex])
                        } else {
                            itemEmprestar(emprestimoPatrimonio.itens[editarLote.rowIndex])
                        }
                        setEditarLote({ visible: false, itemEmprestimo: new ItemEmprestimo(), rowIndex: -1, isItem: false })
                    }
                    else {
                        if (editarLote.itemEmprestimo.inutilizavel) {
                            beforeDevolver();
                        } else {
                            beforeEmprestar();
                        }
                    }
                }}
                onCancel={() => {
                    limpaLotes();
                    setEditarLote({ visible: false, itemEmprestimo: new ItemEmprestimo(), rowIndex: -1, isItem: false });
                }}
            />
            <Dialog header="Inutilizavel" visible={modalInutilizavel.visible} style={{ width: '35vw' }} onHide={() => setModalInutilizavel({ visible: false, data: null, isItem: false })}>
                <div className="row">
                    <label className="col col-sm-12">
                        Patrimonio: {modalInutilizavel.data?.patrimonio?.codigo || 'Não disponível'}
                    </label>
                    <label className="col col-sm-12">
                        Produto: {modalInutilizavel.data?.patrimonio?.produto?.nome || 'Não disponível'}
                    </label>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Label className="col col-sm-12" obrigatorio>Observação inutilizavel</Label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <InputTextarea
                            required
                            value={modalInutilizavel.data?.observacaoInutilizavel || ''}
                            style={{ width: '50%' }}
                            rows={4}
                            onChange={(e) => {
                                setModalInutilizavel(prevState => ({
                                    ...prevState,
                                    data: {
                                        ...prevState.data,
                                        observacaoInutilizavel: e.target.value
                                    }
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <Button label="Confirmar" disabled={!modalInutilizavel.data?.observacaoInutilizavel} style={{ marginRight: 30 }} onClick={() => {
                            let emprestimoPatrimonioLocal = emprestimoPatrimonio;
                            let obs = modalInutilizavel.data?.observacaoInutilizavel;
                            const itemIndex = emprestimoPatrimonioLocal.itens.findIndex((item: ItemEmprestimo) => item.id === modalInutilizavel.data?.id)

                            if (itemIndex !== -1) {
                                emprestimoPatrimonioLocal.itens[itemIndex].observacaoInutilizavel = obs;
                            }

                            setEmprestimoPatrimonio(emprestimoPatrimonioLocal);

                            if (modalInutilizavel.isItem) {
                                itemDevolvido(emprestimoPatrimonio.itens[itemIndex])
                                setModalInutilizavel({ visible: false, data: null, isItem: false });
                            }
                            else {
                                beforeDevolver();
                            }
                        }} />
                    </div>
                </div>
            </Dialog>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Pessoa Emprestada</Label>
                <div className="col-sm-12">
                    <Controller name="pessoaEmprestada" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            disabled={emprestimoPatrimonio.status != "CRIADO" ? true : false}
                            dropdown
                            value={emprestimoPatrimonio.pessoaEmprestada}
                            placeholder="Selecione o Cliente"
                            style={{ width: '50%' }}
                            className={errors.cliente ? "p-invalid" : ""}
                            field="nome"
                            itemTemplate={(item: Pessoa) => item.numeroDocumento + " - " + item.nome}
                            suggestions={pessoasFiltradas}
                            completeMethod={(e) => {
                                let filtered: Pessoa[] = pessoaMethod(pessoas, e.query);
                                setPessoasFiltradas(filtered);
                            }}
                            onChange={(e) => {
                                clearErrors("pessoaEmprestada")

                                let emprestimoPatrimonioLocal = JSON.parse(JSON.stringify(emprestimoPatrimonio));

                                if (!e.target.value) {
                                    emprestimoPatrimonioLocal.pessoaEmprestada = null;
                                } else if (typeof e.target.value == "string") {
                                    let pessoaEmprestada = new Pessoa();
                                    pessoaEmprestada.nome = e.target.value;
                                    emprestimoPatrimonioLocal.pessoaEmprestada = pessoaEmprestada;
                                } else {
                                    emprestimoPatrimonioLocal.pessoaEmprestada = e.target.value;
                                }

                                setEmprestimoPatrimonio(emprestimoPatrimonioLocal);
                            }}
                        />
                    )} />
                </div>
                {errors.pessoaEmprestada && errors.pessoaEmprestada.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.pessoaEmprestada?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data Emprestimo</Label>
                <div className="col-sm-12">
                    <InputText disabled value={emprestimoPatrimonio.dataEmprestimo ? converterDataHora(emprestimoPatrimonio.dataEmprestimo) : ""} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data Prevista para Devolução</Label>
                <div className="col-sm-12">
                    <Controller name="dataPrevistaDevolucao" control={control} render={({ field }) => (
                        <DatePicker
                            disabled={emprestimoPatrimonio.status !== "CRIADO" ? true : false}
                            inputRef={field.ref}
                            value={dayjs(emprestimoPatrimonio.dataPrevistaDevolucao)}
                            onChange={value => {
                                clearErrors("dataPrevistaDevolucao")
                                setEmprestimoPatrimonio({ ...emprestimoPatrimonio, dataPrevistaDevolucao: value?.startOf("day").toDate() || null })
                            }}
                        />
                    )} />
                </div>
                {errors.dataInicio && errors.dataInicio.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataInicio?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Status</Label>
                <div className="col-sm-12">
                    <InputText disabled value={emprestimoPatrimonio.status ? emprestimoPatrimonioService.getStatus(emprestimoPatrimonio.status) : ""} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Observação</Label>
                <div className="col-sm-12">
                    <InputTextarea value={emprestimoPatrimonio.observacao} onChange={(e) => setEmprestimoPatrimonio({ ...emprestimoPatrimonio, observacao: e.target.value })} rows={4} style={{ width: '100%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Itens</Label>
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Itens"
                        getNewModel={() => new ItemEmprestimo()}
                        dataKey="key"
                        lista={emprestimoPatrimonio.itens ? emprestimoPatrimonio.itens : []}
                        setLista={(value: any) => setEmprestimoPatrimonio({ ...emprestimoPatrimonio, itens: value })}
                        scrollable
                        onRowReorder={(e) => {
                            e.value.forEach((item: any, index: number) => {
                                item.sequencial = index + 1;
                            });
                            if (emprestimoPatrimonio) {
                                emprestimoPatrimonio.itens = e.value as ItemEmprestimo[];
                                setEmprestimoPatrimonio({ ...emprestimoPatrimonio });
                            }
                        }}
                        reordable={true}
                        scrollHeight='500px'
                        addButtonDisabled={emprestimoPatrimonio.status !== 'CRIADO'}
                        showDelete={emprestimoPatrimonio.status === 'CRIADO'}
                        showEdit={emprestimoPatrimonio.status === 'CRIADO'}
                    >
                        <Column field="itemProduto" header="produto?"
                            body={(rowData, options: ColumnBodyOptions) =>
                                <Checkbox disabled={rowData.status !== 'CRIADO'} checked={rowData.itemProduto} />
                            }
                            editor={(options) => {
                                return <Checkbox disabled={options.rowData.status !== 'CRIADO'} checked={options.rowData.itemProduto}
                                    onChange={(e) => {
                                        options.rowData.itemProduto = e.checked;

                                        let emprestimoPatrimonioLocal = { ...emprestimoPatrimonio };
                                        emprestimoPatrimonioLocal.itens[options.rowIndex] = {
                                            ...options.rowData,
                                            patrimonio: null,
                                            produto: null,
                                            quantidadeEmprestada: 0
                                        };
                                        emprestaProduto();

                                        setEmprestimoPatrimonio(emprestimoPatrimonioLocal);
                                    }}
                                />
                            }}
                        />
                        <Column
                            header="Patr/Prod"
                            editor={(options) => {
                                return options.rowData.itemProduto ? editorProduto(options) : editorPatrimonio(options)
                            }}
                            body={(rowData) => rowData.itemProduto
                                ? rowData.produto?.nome
                                : rowData.patrimonio?.codigo + " - " + rowData.patrimonio?.produto.nome}
                        />
                        {temProduto ? <Column field="quantidadeEmprestada" header="Quantidade" editor={(options) => editorQuantidade(options)} /> : null}
                        <Column field="dataEmprestimo" header="Data Emprestimo" body={(rowData) => rowData.dataEmprestimo ? converterDataHora(rowData.dataEmprestimo) : ""} />
                        <Column field="dataDevolucao" header="Data Devolução" body={(rowData) => rowData.dataDevolucao ? converterDataHora(rowData.dataDevolucao) : ""} />
                        <Column field="status" header="Status" body={(rowData) => itemEmprestimoService.getStatus(rowData.status)} />
                        {emprestimoPatrimonio.itens.findIndex(item => item.status !== 'CRIADO') > -1 ? <Column field="inutilizavel" header="inutilizavel?"
                            body={(rowData) => <Checkbox disabled={rowData.status !== 'EMPRESTADO'} checked={rowData.inutilizavel} onChange={(e) => {
                                rowData.inutilizavel = e.checked;
                                setEmprestimoPatrimonio({ ...emprestimoPatrimonio });
                            }} />}
                        /> : null}
                        {emprestimoPatrimonio.status !== 'CANCELADO' && emprestimoPatrimonio.status !== "DEVOLVIDO" && emprestimoPatrimonio.id ?
                            <Column header="Ações" body={(rowData, options) => (
                                <div>
                                    {rowData.status === "CRIADO" ? (
                                        <Button label="Emprestar" disabled={alterando} onClick={() => {
                                            {
                                                rowData.itemProduto ? setEditarLote({ visible: true, itemEmprestimo: rowData, rowIndex: options.rowIndex, isItem: true })
                                                    : itemEmprestar(rowData)
                                            }
                                        }}
                                            style={{ marginLeft: 8 }} />
                                    ) : null}
                                    {rowData.status === "EMPRESTADO" ? (
                                        <Button label="Devolução" disabled={alterando} onClick={() => {
                                            rowData.inutilizavel ?
                                                rowData.itemProduto ? setEditarLote({ visible: true, itemEmprestimo: rowData, rowIndex: options.rowIndex, isItem: true }) : setModalInutilizavel({ visible: true, data: rowData, isItem: true }) :
                                                itemDevolvido(rowData)
                                        }} style={{ marginLeft: 8 }} />
                                    ) : null}
                                    {rowData.status !== "CANCELADO" && rowData.status !== "DEVOLVIDO" ? (
                                        <Button label="Cancelar" disabled={alterando} onClick={() => itemCancelar(rowData.id)} style={{ marginLeft: 8 }} />
                                    ) : null}
                                </div>
                            )}
                            /> : null}
                    </BaseDataTableEdit>
                </div>
            </div>
        </BaseCadastro>
    )
}